// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph--paragraph--YX8ak"};